import type { TourDef } from './index';

const a = (id: string): string => `[data-tour="${id}"]`;

export const budgetTour: TourDef = {
  id: 'budget',
  steps: [
    { element: a('budget-period'), popover: { title: 'One period at a time', description: 'Step back to see how a past month went, or forward to plan.' } },
    { element: a('budget-mode'), popover: { title: 'Pick your style', description: 'Category limits, envelopes where every dollar gets a job, or a 50/30/20 plan.' } },
    { element: a('budget-lines'), popover: { title: 'Pace, not just totals', description: 'The dashed marker is where spending would be if it were spread evenly. Ahead of it is worth a look, not a worry.' } },
    { element: a('budget-safe'), popover: { title: 'Safe to spend', description: 'What is left after bills, budgets and goals, with the working shown.' } },
  ],
};
